<aig-modal class="aig-modal-already" position="center" customMaxWidth="600px">
  <div body>
    <div class="p-flexcc u-dir-col u-gap-30 u-mt-8 u-px-8">
      <div class="aig-modal-already">
        <img src="../../../../../assets/images/logos/logo.svg" alt="loog-AIG" width="100%" height="auto">
      </div>
      <p class="u-fs-18 u-color-secondary1 u-fw-400 u-text-center">
        La solicitud de baja de la póliza ya ha sido tramitada.
        Para más información, póngase en contacto con nosotros 
        escribiendo a <a class="u-color-selected1" [href]="'mailto:'+email"> {{ email }} </a>
      </p>

      <div></div>
    </div>
  </div>
  <div buttons>
    <div class="u-size-per-100 u-mb-8 u-px-8">
      <button type="button" class="aig-modal-already__btn e-btn--primary p-flexcc" (click)="clickHide()">
        Aceptar
      </button>
    </div>
  </div>
</aig-modal>
